const Resources = {

    breadcrumb:[
        {
            name:   'Login',
            href:   '/login',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Facility Selection',
            href:   '#',
            arrow:  "",
        },
    ],

    breadcrumb_reset_password:[
        {
            name:   'Login',
            href:   '/login',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Reset Password',
            href:   '#',
            arrow:  "",
        },
    ],

}

export default Resources;